import { useEffect, useState } from 'react'

export default function AsanaCallback() {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const error = params.get('error')

    if (error || !code) {
      window.opener?.postMessage({ type: 'asana-callback', error: true }, window.location.origin)
      setStatus('error')
      setTimeout(() => window.close(), 1500)
      return
    }

    // Pass the code back to the parent window (Settings page handles token exchange)
    window.opener?.postMessage({ type: 'asana-callback', code }, window.location.origin)
    setStatus('success')
    setTimeout(() => window.close(), 1500)
  }, [])

  return (
    <div className="flex items-center justify-center h-screen bg-white">
      <div className="text-center space-y-3">
        {status === 'loading' && (
          <>
            <svg className="animate-spin mx-auto w-8 h-8 text-[#005EB8]" viewBox="0 0 24 24" fill="none">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
            </svg>
            <p className="text-slate-500 text-sm">Connecting to Asana...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="mx-auto w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
              <svg className="w-5 h-5 text-emerald-600" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z" clipRule="evenodd" />
              </svg>
            </div>
            <p className="text-emerald-600 text-sm font-medium">Connected! Closing...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="mx-auto w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
              <svg className="w-5 h-5 text-red-600" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v4a1 1 0 102 0V7zm-1 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
              </svg>
            </div>
            <p className="text-red-600 text-sm font-medium">Connection failed. Closing...</p>
          </>
        )}
      </div>
    </div>
  )
}
